import styled from 'styled-components'

import { TextField } from '@material-ui/core'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export const Input = styled(TextField)`
  background-color: ${ colors.green2 };
  border-radius: 2rem;
  margin: 0;

  &:hover {
    opacity: 0.85;
  }

  & > div > input,
  & > div button {
    color: ${ colors.white };
    font-weight: ${ fonts.fontWeight.bold }
  }

  & > div button.MuiAutocomplete-popupIndicator {
    padding: 3px;
  }

  & .MuiAutocomplete-endAdornment {
    right: 0.5rem;
  }

  & .MuiInput-underline:before,
  & .MuiInput-underline:after,
  & .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: 0;
  }

  & > label {
    visibility: hidden;

    & + .MuiInput-formControl {
      margin: 0.3rem 0;
      padding: 0 1rem;
    }
  }
`
